'use client'
import { Image } from '@/lib/next-shim'
import { useTranslations } from '@/lib/next-shim'

import noResults from '@/assets/svg/no-results.svg'
import { GetMyInfosQuery } from '@/core/graphql/types'
import { DeleteOrderDialog, OrderCard, useDeleteOrder } from '@/entities/order'

import { DashboardCarousel } from './DashboardCarousel'
import { DashboardSection } from './DashboardSection'

type OrdersProps = {
  orders: GetMyInfosQuery['myInfos']['orders']
}

export function Orders({ orders }: OrdersProps) {
  const t = useTranslations()

  return (
    <DashboardSection title={t('account.sections.Orders.title')} count={orders.length} viewAllHref="/account/orders">
      <OrdersList orders={orders} />
    </DashboardSection>
  )
}

function OrdersList({ orders }: { orders: GetMyInfosQuery['myInfos']['orders'] }) {
  const t = useTranslations()
  const { orderToDelete, requestDelete, cancelDelete, confirmDelete } = useDeleteOrder()

  if (!orders.length) {
    return (
      <div className="flex flex-row w-full m-5 px-5 bg-white rounded-lg shadow items-center justify-between md:justify-center h-20 md:h-32">
        <p className="text-sm sm:text-md md:text:lg font-normal text-zinc-500">{t('base.noData')}</p>
        <Image alt="notFound" className="h-full w-auto" src={noResults} />
      </div>
    )
  }

  return (
    <>
      <DashboardCarousel
        items={orders}
        getItemKey={(order) => order._id}
        renderItem={(order) => <OrderCard className="w-full" order={order} onDelete={requestDelete} />}
      />
      {orderToDelete && <DeleteOrderDialog onCancel={cancelDelete} onConfirm={confirmDelete} />}
    </>
  )
}
